import React from "react";
import { ProductsTableSkuColumnProps } from "./products-table-sku-column.props";
import { ResponsiveTableCell } from "../../../../components/layout/responsive-table/responsive-table-cell.component";

export const ProductsTableSkuColumn = (props: ProductsTableSkuColumnProps) => (
  <ResponsiveTableCell active={props.active} className="wide pad-left" component="th" scope="row">
    {props.sku}
  </ResponsiveTableCell>
);
